import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";

function HeroSetion({ companies }) {
  const { scrollY } = useScroll();

  const y = useTransform(scrollY, [0, 350], [300, 30]);
  const x = useTransform(scrollY, [0, 100], [0, 0]);
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <motion.div
      style={{ y, x }}
      className="flex flex-col justify-center items-center w-full lg:py-2"
    >
      <motion.div
        initial={{ y: 50 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex justify-center items-center w-full"
      >
        <div
          className="py-24 lg:py-32 bg-mainColor w-full lg:mx-14 mx-5 rounded-2xl relative overflow-hidden flex flex-col justify-center items-center space-y-6"
          style={{
            backgroundImage:
              "repeating-linear-gradient(to right, transparent, rgba(0, 0, 0, 0.2) 85px, rgba(255, 255, 255, 0.2) 100px, transparent 100px)",
            backgroundBlendMode: "overlay",
          }}
        >
          <div className="absolute -top-48 -left-5 py-96 px-40 rotate-[60deg] bg-[#2a4673] filter blur-3xl opacity-60 rounded-full brightness-125 animate-oval-one"></div>
          <div className="absolute -bottom-48 right-0 py-96 px-40 rotate-[60deg] bg-[#352678] filter blur-3xl opacity-60 rounded-full brightness-125 animate-oval-two"></div>

          <div className="absolute w-2 h-2 top-60 left-32 bg-white blur-sm rounded-full"></div>
          <div className="absolute w-2 h-2 top-80 left-10 bg-white blur-sm rounded-full"></div>
          <div className="absolute w-2 h-2 top-96 left-40 bg-white blur-sm rounded-full"></div>

          <div className="absolute w-2 h-2 top-60 right-20 bg-white blur-sm rounded-full"></div>
          <div className="absolute w-2 h-2 top-80 right-60 bg-white blur-sm rounded-full"></div>
          <div className="absolute w-2 h-2 top-96 right-32 bg-white blur-sm rounded-full"></div>

          <div className="mt-10 md:text-sm text-xs text-white flex px-10 lg:px-14 py-3 rounded-full b backdrop-blur-md border-white border border-opacity-60 shadow-lg z-10">
            E-learning.io
          </div>

          <div className="lg:text-5xl md:text-4xl text-3xl text-white lg:w-7/12 w-10/12 text-center mt-8 leading-snug z-10">
            Your Gateway to Personalized Online Education
          </div>

          <div className="text-sm text-center font-light mt-6 md:w-2/4 w-3/4 text-gray-100 z-10">
            Join millions transforming their careers through flexible,
            expert-led online education.
          </div>

          <Link
            to="/auth"
            className="bg-white text-blue-700 lg:text-sm text-xs font-medium px-12 py-3 rounded-full shadow-md hover:bg-gray-200 transition z-10"
          >
            Signup
          </Link>
        </div>
      </motion.div>

      <div className="my-6">
        <div className="overflow-hidden relative w-full mx-auto">
          <div className="absolute inset-0 z-10">
            <div className="absolute -left-1 top-0 w-1/6 h-full bg-gradient-to-r from-white to-transparent filter blur-sm"></div>
            <div className="absolute -right-1 top-0 w-1/6 h-full bg-gradient-to-l from-white to-transparent filter blur-sm"></div>
          </div>

          <motion.div
            className="flex"
            animate={{
              x: ["0%", "-100%"],
            }}
            transition={{
              ease: "linear",
              duration: 15,
              repeat: Infinity,
            }}
          >
            {duplicatedCompanies.map((company, index) => (
              <div
                key={index}
                className="flex-shrink-0 flex justify-center items-center select-none"
                style={{ width: `${100 / companies.length}%` }}
              >
                <img
                  src={company.img}
                  alt={`Company ${company.id}`}
                  className="lg:w-24 lg:h-24 md:w-16 md:h-16 w-12 h-12 object-contain"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}

export default HeroSetion;
